module.exports = __webpack_public_path__ + "static/media/return.4c56a5d6.svg";